/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery(".scrolldown").click(function(){
		jQuery('html, body').animate({
			scrollTop: window.pageYOffset + (jQuery(window).height()-45)+'px'
		}, 800);
	});

	jQuery(".hamburger").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
	});


	jQuery('<?xml version="1.0" encoding="UTF-8"?>\n' +
		'<svg viewBox="0 0 813.93 14.863" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">\n' +
		'<path transform="translate(994.07 -149.18) rotate(90)" d="m164.05 985.84c-3.151-143.64-4.4-303.79-4.83-444.95-0.386-125.41 2.9-354.75 2.9-354.75s-5.581-13.529-8.841 0c-4.5 290.8-6.759 533.09 1.112 799.7-0.744 9.425 8.544 12.398 9.659-4e-3z" fill="green" data-name="Pfad 79"/>\n' +
		'</svg>').appendTo( "#main-nav .menu-item, .under h2, .underline, .vc_tta-title-text, .apartment h3, .pageheader.niedig .headertitle h1");

	jQuery('.gallery').featherlightGallery({
		gallery: {
			fadeIn: 300,
			fadeOut: 300,
		},
		openSpeed:    300,
		closeSpeed:   300
	});

	jQuery('#preloader').delay( 50 ).slideUp(600); // will fade out the white DIV that covers the website.
	jQuery('#status	').fadeOut(150);



	window.onscroll = function() {myFunction()};
});

jQuery(window).scroll(function() {
	var top = 0;

	jQuery(".under, .apartment, .pageheader.niedig").each(function(){
		top = jQuery(this).offset().top - jQuery(window).height()*0.75;
		if (jQuery(window).scrollTop() >= top){
			if(jQuery(this).hasClass('linein')){
			}else{
				jQuery(this).addClass("linein");
			}
		}else if(jQuery(window).scrollTop() < top){
			if(jQuery(this).hasClass('linein')){
				jQuery(this).removeClass("linein");
			}
		}
	});
});



function myFunction() {
	var header = document.getElementById("top-bar-menu");
	var sticky = header.offsetTop;
	if (window.pageYOffset > sticky) {
		header.classList.add("sticky");
	} else {
		header.classList.remove("sticky");
	}
}